import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  VertCarousel, VertContainer, Row, Col, VertTypography, VertButton, VertSkeleton,
} from '@vertem-core/vertice-ds';
import MediaQuery from 'react-responsive';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import StoreItem from './components/StoreCarousel/components/StoreItem';
import usePipeContext from '../../Services/Providers/PipeProvider/usePipeContext';

const ShowcaseLoading = () => {
  return (
    <VertContainer fluid className="margin-bottom-big">
      <VertContainer data-testid="vert-box-showcase-store" className="vert-box-showcase  margin-bottom-regular" spacingX="regular">
        <Row justify="center" align="middle" className="vert-box-showcase-title padding-x-extra-small" gutter={8}>
          <Col flex="auto" className="vert-box-showcase-title-label">
            <VertSkeleton paragraph={{ rows: 0 }} />
          </Col>
        </Row>
      </VertContainer>
      <VertContainer className="vert-box-showcase" spacingX="regular">
        <Row className="vert-showcase-wrapper" gutter={8}>
          <MediaQuery
            minWidth={768}
          >
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr',
              width: '100%',
            }}
            >
              <div className="StoreItem">
                <section
                  className="StoreItem-box"
                >
                  <VertSkeleton.Avatar
                    style={{
                      width: '82px',
                      height: '82px',
                    }}
                    shape="circle"
                  />
                  <div>
                    <VertSkeleton paragraph={{ rows: 2 }} />
                  </div>
                </section>
              </div>
              <div className="StoreItem">
                <section
                  className="StoreItem-box"
                >
                  <VertSkeleton.Avatar
                    style={{
                      width: '82px',
                      height: '82px',
                    }}
                    shape="circle"
                  />
                  <div>
                    <VertSkeleton paragraph={{ rows: 2 }} />
                  </div>
                </section>
              </div>
              <div className="StoreItem">
                <section
                  className="StoreItem-box"
                >
                  <VertSkeleton.Avatar
                    style={{
                      width: '82px',
                      height: '82px',
                    }}
                    shape="circle"
                  />
                  <div>
                    <VertSkeleton paragraph={{ rows: 2 }} />
                  </div>
                </section>
              </div>
              <div className="StoreItem">
                <section
                  className="StoreItem-box"
                >
                  <VertSkeleton.Avatar
                    style={{
                      width: '82px',
                      height: '82px',
                    }}
                    shape="circle"
                  />
                  <div>
                    <VertSkeleton paragraph={{ rows: 2 }} />
                  </div>
                </section>
              </div>
            </div>
          </MediaQuery>
          <MediaQuery
            maxWidth={769}
          >
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              width: '100%',
              boxSizing: 'border-box',
            }}
            >
              <div className="StoreItem">
                <section
                  className="StoreItem-box"
                >
                  <VertSkeleton.Avatar
                    style={{
                      width: '82px',
                      height: '82px',
                    }}
                    shape="circle"
                  />
                  <div>
                    <VertSkeleton paragraph={{ rows: 2 }} />
                  </div>
                </section>
              </div>
            </div>
          </MediaQuery>
        </Row>
      </VertContainer>
    </VertContainer>
  );
};
const ShowcaseStoreWrapper = ({ children }) => {
  
  const Navigate = useNavigate();
  
  const settings = {
    slidesToShow: 4,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px 0px 0px 0px',
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px 0px 0px 0px',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px 0px 0px 0px',
        },
      },
    ],
  };

  return (
    <VertContainer fluid className="margin-bottom-big">
      <VertContainer data-testid="vert-box-showcase-store" className="vert-box-showcase  margin-bottom-regular" spacingX="regular">
        <Row justify="center" align="middle" className="vert-box-showcase-title padding-x-extra-small" gutter={8}>
          <Col flex="auto" className="vert-box-showcase-title-label">
            <MediaQuery maxWidth={768}>
              <VertTypography.Title level={2} className="margin-bottom-none">Lojas</VertTypography.Title>
            </MediaQuery>
            <MediaQuery minWidth={769}>
              <VertTypography.Title level={2} className="margin-bottom-none">As melhores lojas pra você</VertTypography.Title>
            </MediaQuery>
          </Col>
          <Col flex="none" className="vert-box-showcase-title-button">
            <VertButton onClick={() => {
                  Navigate('/stores');
                }} type="link" spacing="none" size="small" className="color-detached">
              Mostrar todos
            </VertButton>
          </Col>
        </Row>
      </VertContainer>
      <VertContainer className="vert-box-showcase" spacingX="regular">
        <Row className="vert-showcase-wrapper" gutter={8}>
          <VertCarousel
          ScrollToFirstItem
            {...settings}
          >
            {children}
          </VertCarousel>
        </Row>
      </VertContainer>
    </VertContainer>
  );
};
ShowcaseStoreWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const ShowcaseStore = () => {
  const Stores = useSelector(({ Stores: data }) => ({ ...data }));
  const userProfile = useSelector((state) => state?.oidc?.user?.profile);
  const { callApi } = usePipeContext();



  useEffect(() => {
    
    if (!Stores.ecommerce.length) {
      callApi({
        symbol: 'FETCH_STORES',
        alias: null,
        payload: {
          catalogId: userProfile['custom:catalog_id'],
        },
      });
    }
  }, [Stores.ecommerce]);

  if (Stores.isLoading) {
   
    return <ShowcaseLoading />;
  }

   if (!Stores || !Stores.ecommerce.length) return null;
  const items = Stores.ecommerce.slice(0, 8).map((item) => {
    return (
      <StoreItem key={item.id} data-testid={`carousel-item-${item.id}`} data={item} />
    );
  });
  return (
    <ShowcaseStoreWrapper>
      {items}
    </ShowcaseStoreWrapper>
  );
};

export default ShowcaseStore;
